import 'babel-polyfill'

import {format} from 'date-fns'
import {ru} from 'date-fns/locale'
import axios from 'axios'

import Vue from 'vue'
import App from '@/App.vue'

import store from '@/store'
import router from '@/router'
import vuetify from './plugins/vuetify'

import Toasted from 'vue-toasted';
import {Vue2Storage} from 'vue2-storage'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);

Vue.use(Vue2Storage, {
    prefix: 'app_',
    driver: 'local',
    ttl: 60 * 60 * 24 * 1000 // 24 часа
})

Vue.use(VueYandexMetrika, {
    id: 62918485,
    router: router,
    env: process.env.NODE_ENV,
    scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
    options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
        trackHash: true
    }
})

Vue.use(Toasted);

Vue.filter('localize', function (value, str_format = 'd MMMM yyyy HH:mm') {
    // let time = Date.parse(value);
    // let date = new Date(time - (new Date().getTimezoneOffset() * 60 * 1000));
    let date = new Date(Date.parse(value));
    return format(
        date,
        str_format,
        {locale: ru}
    )
});

Vue.filter('truncate', function (text, value) {
    if (text.length - value >= 3) {
        return text.slice(0, value) + '...'
    } else {
        return text
    }
})

Vue.config.productionTip = false;

const vue = new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
});

Vue.prototype.$storage = vue.$storage;

var isEvent = false;
Vue.prototype.$dateNow = function () {
    if (!isEvent) {
        localStorage.setItem('dateNowUTC', new Date(Date.now()).toISOString())
        isEvent = true;
        setTimeout(function () {
            axios.get(`/api/datenow/`)
                .then(response => {
                    localStorage.setItem('dateNowUTC', response.data.currentDateTime)
                })
        }, 1000);
    }
    return new Date(Date.parse(localStorage.getItem('dateNowUTC')))
}

Vue.directive('only-number', {
    bind: function (el, binding) {
        el.onkeypress = function (e) {
            const val = e.target._value + ''
            const float = binding.modifiers.float
            if (
                (isNaN(e.key) || [' '].includes(e.key)) &&
                (e.key !== '.' || val.includes('.') || !float) &&
                (e.key !== '-' || val[0] === '-'|| e.target.selectionStart !== 0)
            ) {
                e.preventDefault()
            }
        }
    }
})

// Vue.prototype.$printer = null;
// Vue.prototype.$encoder = null;

// eslint-disable-next-line no-undef
vue.$mount('#app');


